<div class="icon-container"><mat-icon class="icon">warning</mat-icon></div>
<h1 *ngIf="isLite" [innerHTML]="'COMMON.FORBIDDEN_FOR_LITE_ACCOUNT_MSG' | translate"></h1>
<h1 *ngIf="!isLite" [innerHTML]="'COMMON.FORBIDDEN_MSG' | translate"></h1>
